import styled, { css, keyframes } from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

export interface ContentProps {
  showLoading: boolean;
}

export interface ChildrenProps extends ContentProps {
  hide: boolean;
  opacity: number;
}

const BaseWrapper = styled.div``;

export const TopPanel = styled.div`
  padding: 32px;
  border-bottom: 8px solid ${colors.blueGrey10};
`;

export const ContentContainer = styled.div`
  padding: 32px;
  border-bottom: 2px solid ${colors.blueGrey10};
`;

export const PrivacyWrapper = styled.div`
  padding: 32px;

  a {
    color: ${colors.orange};
  }
`;

export const Display = {
  DesktopTablet: styled(BaseWrapper)`
    display: none;
    @media ${device.isDesktop}, ${device.isTablet} {
      display: flex;
    }
  `,
  Mobile: styled(BaseWrapper)`
    display: none;
    @media ${device.isMobile} {
      display: flex;
    }
  `
};

/**
 * Animation delay for fadeIn
 */
const animateDelay = '0.5s';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const animateFadeIn = (props: ContentProps) => {
  return (
    !props.showLoading &&
    css`
      animation: ${fadeIn} ease ${animateDelay};
    `
  );
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Content = styled.main<ContentProps>`
  flex-grow: 1;
  ${props =>
    props.showLoading &&
    `display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      min-height: 50vh;`};
`;

export const LoadingSpinner = styled.div<ContentProps>`
  ${props =>
    props.showLoading
      ? css`
          position: absolute;
          animation: ${fadeIn} ease ${animateDelay};
        `
      : `display: none;`}
`;

export const ChildrenWrapper = styled.div<ChildrenProps>`
  height: 100%;
  ${props =>
    props.hide &&
    `opacity: ${props.opacity};
    pointer-events: none;
    width: 100%;
    z-index: 0;`};
  ${animateFadeIn}
`;

export const PaymentMethods = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const IconWrapper = styled.div`
  width: 100%;
  max-width: 90px;
  margin-right: 16px;
  margin-bottom: 16px;
  &:last-child {
    margin-right: 0;
  }
  svg {
    width: 100%;
    height: 100%;
  }
`;
